export default "/img/MH.7c31fae867429136c4436cd5fad42b85.png";